
import { P } from 'af-table-column';
import http from './http';

let baseUrl = '/conference-web'

// 更新会议提报单
const createOrUpdateDeclarationPrint = (param) => {
  return new Promise((resolve, reject) => {
      http
          .post(baseUrl + "/declaration/createOrUpdateDeclarationPrint", param, false)
          .then(result => {
              resolve(result);
          })
          .catch(error => {
              reject(error);
          });
  });
}

//获取打印信息中的审批信息
const queryApproveInfoOfDeclaration = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.get(baseUrl + '/declaration/queryApproveInfoOfDeclaration', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 查询会议提报列表
const getDeclarationList = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.get(baseUrl+'/declaration/list', reqParam, true).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 新建提报单
const addNewDeclaration = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.post(baseUrl + '/declaration', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 查询特定提报
const getDeclarationDetail = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.get(baseUrl + '/declaration', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 修改提报单
const editDeclaration = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.put(baseUrl + '/declaration', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 更新上会状态
const updateUpMeetingStatus = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.put(baseUrl + '/declaration/submit', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 更新上会状态（批量）
const updateMulUpMeetingStatus = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.put(baseUrl + '/declaration/batch/submit', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

//查询当前审批流
const queryApproveProcess = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.get('/common-web/approve/queryCurrentApproveProcess', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 提交审批
const submitApproveProcess = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.post( '/common-web/approve/submitApproveProcess', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 删除会议提报
const deleteDeclaration = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.delete(baseUrl + '/declaration', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 撤回提报单
const recallDeclaration = (reqParam) => {
  return new Promise((resolve, reject) => {
      http.post('/common-web/approve/recall', reqParam, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 获取项目分类字典列表
const getProjectTypeList = () => {
  let reqParam = { category: 'DECLARATIONPROJECTTYPE' }
  return new Promise((resolve, reject) => {
      http.get(baseUrl + '/declaration/sysDictDetail', reqParam, true).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

// 上传附件
const uploadConferenceFile = (param) => {
  return new Promise((resolve, reject) => {
    http
      .post(baseUrl + "/oss/upload/conference/items", param, false, true, true)
      .then(result => {
        resolve(result);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 创建审批流
 * */
 const createApproveProcessService = (params) => {
  return new Promise((resolve, reject) => {
      http.post("/common-web/approve/createApproveProcess", params, false).then(result => {
          resolve(result);
      }).catch(error => {
          reject(error);
      })
  });
}

const queryApproveHistory = (params) => {
  return new Promise((resolve, reject) => {
    http.get("/common-web/approve/queryApproveProcess", params, true).then(result => {
      resolve(result);
    }).catch(error => {
      reject(error)
    })
  })
}


const queryRealApproveProcess = (params) => {
  return new Promise((resolve, reject) => {
    http.get("/common-web/approve/queryRealApproveProcess", params, true).then(result => {
      resolve(result);
    }).catch(error => {
      reject(error)
    })
  })
}

//审批通过后，上传会议提报单附件
const insertMeetingAfterAudit = param => {
  return new Promise((resolve, reject) => {
      http
          .post(baseUrl + "/declaration/insertItemsAfterAudit", param)
          .then(result => {
              resolve(result);
          })
          .catch(error => {
              reject(error);
          });
  });
};

//删除会议提报单审批通过后上传的附件
const deleteMeetingAfterAudit = data => {
  return new Promise((resolve, reject) => {
      http
          .post(baseUrl + "/declaration/deleteItemsAfterAudit", data)
          .then(result => {
              resolve(result);
          })
          .catch(error => {
              reject(error);
          });
  });
};

export {
  createOrUpdateDeclarationPrint,
  queryApproveInfoOfDeclaration,
  getDeclarationList,
  addNewDeclaration,
  getProjectTypeList,
  uploadConferenceFile,
  getDeclarationDetail,
  deleteDeclaration,
  queryApproveProcess,
  submitApproveProcess,
  editDeclaration,
  updateUpMeetingStatus, //修改上会状态
  updateMulUpMeetingStatus,
  recallDeclaration,
  createApproveProcessService,
  queryApproveHistory,
  queryRealApproveProcess,
  insertMeetingAfterAudit,
  deleteMeetingAfterAudit,
}